var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93414 17.501H0.290314V5.81738H3.93414V17.501ZM2.11027 4.22362C0.945089 4.22362 0 3.26269 0 2.10253C8.33985e-09 1.54527 0.222331 1.01082 0.618083 0.616778C1.01384 0.222732 1.55059 0.00135946 2.11027 0.00135946C2.66995 0.00135946 3.2067 0.222732 3.60245 0.616778C3.9982 1.01082 4.22054 1.54527 4.22054 2.10253C4.22054 3.26269 3.27505 4.22362 2.11027 4.22362ZM17.5718 17.501H13.9358V11.8135C13.9358 10.458 13.9084 8.71972 12.0414 8.71972C10.1469 8.71972 9.85655 10.1924 9.85655 11.7158V17.501H6.21664V5.81738H9.71139V7.41113H9.76239C10.2489 6.49316 11.4372 5.52441 13.2101 5.52441C16.8978 5.52441 17.5758 7.94238 17.5758 11.083V17.501H17.5718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4d3131af388ebb657285b235cbf98572.svg";
export { ForwardRef as ReactComponent };